import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

export function useConferenceId() {
    const { pathname } = useLocation();

    return useMemo(() => {
        const match = pathname.match(/\/j\/(\d+)/);

        return match && match[1] ? match[1] : null;
    }, [pathname]);
}
